import { FC } from "react";
import { BreakableName } from "../../../helper/general/methods";

interface FolderIconProps {
  folderName: string;
  isForged: boolean;
  isSelected: boolean;
  onClick: () => void;
}

const FolderIcon: FC<FolderIconProps> = ({
  folderName,
  isForged,
  isSelected,
  onClick,
}) => {
  return (
    <div
      className={isSelected ? "selectedItem" : "unSelectedItem"}
      onClick={onClick} // Directly passing the onClick handler
    >
      <div className="itemGraphic">
        <img
          className="icon-big"
          src="assets/icons/folder.png"
          draggable="false"
          alt={folderName}
        />
        {isForged ? (
          // One folder can be the origin or destination of several forges, so
          // the marker only says that some forge uses it; the forges
          // themselves stay at the project root.
          <img
            className="forgedMarker"
            src="assets/icons/forge.png"
            draggable="false"
            alt=""
            title="Used by a forge, as its origin, its destination, or both."
          />
        ) : (
          <></>
        )}
      </div>
      <span title={folderName}>{BreakableName(folderName)}</span>
    </div>
  );
};

export default FolderIcon;
